function equal(a, b) {
  // eslint-disable-next-line eqeqeq
  return a == b;
}

equal.op = '==';

export default equal;
